// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgLabel: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M23.387 11.134a1.5 1.5 0 0 1 0 1.732L18.2 20.2a2.548 2.548 0 0 1-.95.833c-.389.2-.806.3-1.25.3H2.667a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 0 18.667V5.333C0 4.6.261 3.973.783 3.45a2.568 2.568 0 0 1 1.884-.783H16c.444 0 .861.1 1.25.3.389.2.706.478.95.833z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgLabel);
export default Memo;
